import { InboundOrderListPage } from "@/features/inbound-order/pages/InboundOrderListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inbound-order/")({
	component: InboundOrderListPage,
});
